import { StripeExternalAccountService } from '@modules/stripe/stripe-external-account/stripe-external-account-service'
import Errors from '@shared/error/errors';
import Message from '@shared/message/message';
import { i18n } from '@shared/i18n';

export default {
    namespaced: true,

    state: {
        loadingPayoutsMethods: false,
        payoutsMethods: [],
    },
    getters: {
        payoutsMethods: state => state.payoutsMethods,
        loadingPayoutsMethods: state => state.loadingPayoutsMethods,
    },
    mutations: {
        SET_PAYOUT_METHODS(state, payload) {
            state.payoutsMethods = payload;
        },
        SET_LOADING(state, payload) {
            state.loadingPayoutsMethods = payload;
        },
        LIST_PAYOUT_METHODS_STARTED(state) {
            state.loadingPayoutsMethods = true;
        },
        LIST_PAYOUT_METHODS_SUCCESS(state, payload) {
            state.payoutsMethods = payload;
            state.loadingPayoutsMethods = false;
        },
        LIST_PAYOUT_METHODS_ERROR(state) {
            state.loadingPayoutsMethods = false;
        },
    },
    actions: {
        async doSetDefault({ commit, dispatch }, { id, propertyId, subpropertyId, connectedAccountId }) {
            try {
                commit('SET_LOADING', true);
                await StripeExternalAccountService.setDefault({ 
                    id,
                    propertyId: propertyId,
                    subpropertyId: subpropertyId
                });
                await dispatch('doList', { propertyId, connectedAccountId });
                Message.success(i18n('subpropertySettings.finantial.payoutMethods.setDefaultSuccess'));
            } catch (error) {
                commit('LIST_PAYOUT_METHODS_ERROR');
                Errors.handle(error);
            } finally {
                commit('SET_LOADING', false);
            }
        },

        async doDestroy({ commit, dispatch }, { id, propertyId, subpropertyId, connectedAccountId } ) {
            try {
                commit('SET_LOADING', true)
                await StripeExternalAccountService.destroy({
                    id,
                    propertyId: propertyId,
                    subpropertyId: subpropertyId
                });
                await dispatch('doList', { propertyId, connectedAccountId });
                Message.success(i18n('subpropertySettings.finantial.payoutMethods.removeSuccess'));
            } catch (error) {
                commit('LIST_PAYOUT_METHODS_ERROR');
                Errors.handle(error);
            } finally {
                commit('SET_LOADING', false);
            }
        },

        async doList({ commit }, { propertyId, connectedAccountId }) {
            commit('LIST_PAYOUT_METHODS_STARTED');
            
            const filter = null;
            const orderBy = null;
            const limit = 0;
            const offset = 0;

            try {
                const { rows } = await StripeExternalAccountService.list(propertyId, connectedAccountId, filter, limit, offset, orderBy);
                commit('LIST_PAYOUT_METHODS_SUCCESS', rows);

            } catch (error) {
                commit('LIST_PAYOUT_METHODS_ERROR');
                Errors.handle(error);
            }
        },
        
    }
};

